import { initializeBrowserApp } from './renderer/utils/initialize-browser-app';

window.addEventListener('load', function () {
    initializeBrowserApp();
});
